
import { SpotifyRedirectStyle } from "./SpotifyRedirect.style";

type SpotifyRedirectProps = {
  externalUrl: string;
  showLabel?: boolean;
};

const SpotifyRedirect1 = (props: SpotifyRedirectProps) => {
  const { externalUrl, showLabel = true } = props;

  return (
    <SpotifyRedirectStyle
      className="spotify-redirect1"
      href={externalUrl}
      target="_blank"
    >
      <img alt="spotifyLogo" src="./static/spotify-logo.png" className="images" width="30px" />
      <span className="redirect-text">{showLabel}</span>
    </SpotifyRedirectStyle>
  );
};

export default SpotifyRedirect1;
